import CMSService from "@/services/CMSService";
import { root } from "@/common/consts";
export default {
    props: {
        slug: {
            type: String
        }
    },
    data() {
        return {
            root,
            moreLink: root.ABBREVIATIONS,
            relatedArticles: [],
            error: false
        };
    },
    async created() {
        await this.refreshComponent();
    },
    watch: {
        $route() {
            this.refreshComponent();
        }
    },
    methods: {
        async refreshComponent() {
            try {
                const response = await CMSService.getRelatedContent(this.slug);

                const relatedArticles = response.data.data;
                if (relatedArticles.length < 1) {
                    this.error = true;
                } else if (relatedArticles.length >= 1) {
                    this.error = false;
                    this.relatedArticles = relatedArticles;
                }
            } catch (error) {
                this.error = true;
            }
        },
        articleUrl(slug) {
            const parts = slug.split(".").slice(1);
            return `https://${parts.shift()}.yourdictionary.com/${parts.join("/")}.html`;
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/RelatedContent/RelatedContent.js